import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../../services/agent";
import { BaseModel } from "./base-model";

export enum JumpAuditTypes{
	NA = 0,
	DataView = 1,
	DataChange = 2,
	AccessFailure = 3,
	PermissionCheck = 4,
	RequestError = 5
}

export class Audit extends BaseModel {
	@observable title : string;
	@observable content : string;
	@observable username : string;
	@observable surveyId : string;
	@observable userId : string;
	@observable path : string;
	@observable method : string;
	@observable projectId : string;
	@observable appId: string;
	@observable created: Date;
	@observable type: number;
	@observable typeName: string;
	@observable appName: string;


	constructor(data : any = {}) {
		super(data);
		this.fromJSON(data);
	}

	@action fromJSON(data : any = {}){
		super.fromJSON(data);
		if (data) {
			switch(data.type){
				case JumpAuditTypes.DataChange:
					this.typeName = "DataChange";
					break;

				case JumpAuditTypes.DataView:
					this.typeName = "DataView";
					break;

				case JumpAuditTypes.PermissionCheck:
					this.typeName = "PermissionCheck";
					break;

				case JumpAuditTypes.NA:
					this.typeName = "NA";
					break;

				default:
					log.error(`unknow audit type ${data.type}`);
					break;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/stores/models/audit.ts